import { forwardRef } from "react"

import Input from "@molecules/Form/inputs/Input/Input"
import { InputProps } from "@molecules/Form/inputs/Input/Input.types"

import styles from "./NumberInput.module.scss"

function NumberInput<T>(props: InputProps<T>, ref: React.Ref<HTMLInputElement>) {
    const { ...rest } = props

    return (
        <span className={styles.base}>
            <Input ref={ref} type="number" {...rest} />
        </span>
    )
}

interface NumberInputComponent {
    <T>(props: InputProps<T> & React.RefAttributes<HTMLInputElement>): React.ReactElement | null
    displayName?: string
}

const NumberInputWithRef = forwardRef(NumberInput) as unknown as NumberInputComponent
NumberInputWithRef.displayName = "Input"

export default NumberInputWithRef
